import { DropdownIcon } from "app/components/Icons";
import MemberSelection from "app/containers/Features/components/MemberSelection";
import {
  filterActiveTeamMembers,
  getMembersByIds,
} from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import {
  IMemberList
} from "app/containers/Features/components/MemberSelection/types";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AvatarGroup from "../../../TeamSettings/components/AvatarGroup";
import { actions } from "../../redux/slice";

interface Props {
  selectedIds: string[];
}
const SprintMember: React.FC<Props> = ({ selectedIds }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const members = useSelector(selectProjectMemberList);
  const activeMember = filterActiveTeamMembers(members);
  const owners = useMemo(() => {
    return getMembersByIds(members, selectedIds);
  }, [members, selectedIds]);

  const handleSelect = (member: IMemberList) => {
    const current = Array.isArray(selectedIds) ? selectedIds : []; // fallback

    const updatedIds = current.includes(member._id)
      ? current.filter((id) => id !== member._id)
      : [...current, member._id];

    dispatch(actions.setSprintMembers(updatedIds));
  };
  const isAllSelected = owners.length === members.length;

  const handleSelectAll = () => {
    if (isAllSelected) {
      dispatch(actions.setSprintMembers([]));
    } else {
      const allIds = members.map((item) => item._id);
      dispatch(actions.setSprintMembers(allIds));
    }
  };

  return (
    <div className="flex flex-col gap-[6px] group">
      <label className="text-xs font-normal text-secondary">Members</label>
      <MemberSelection
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        trigger={
          <div
            className={`flex items-center gap-[8px] flex-row border rounded-[4px] py-[16px] px-[10px] h-[48px]  ${
              open ? "border-secondary !border-[1px]" : "border-[#E9ECF2]"
            } `}
          >
            <button className="flex items-center justify-between text-sm rounded w-full text-gray-700 leading-[21px] focus:outline-none placeholder:text-[#BDC0C3] placeholder:font-normal placeholder:text-sm placeholder:leading-[21px]">
              {selectedIds?.length > 0 ? (
                <div className="flex items-center gap-1 w-full truncate ">
                  <AvatarGroup
                    membersIds={selectedIds}
                    maxVisible={10}
                    className=" !w-6 !h-6 "
                    memberListData={activeMember}
                  />
                </div>
              ) : (
                <span className="font-normal text-sm leading-[21px] text-[#BDC0C3]">
                  Choose members
                </span>
              )}
              <div
                className={`size-[16px] min-w-[16px] transition-transform duration-300 ease-in-out ${
                  open ? "rotate-180" : ""
                }`}
              >
                <DropdownIcon size={16} />
              </div>
            </button>
          </div>
        }
        selectedValue={selectedIds}
        updateValue={(member) => {
          handleSelect(member);
        }}
        handleSelectAll={handleSelectAll}
        options={activeMember}
        headingText="Members"
        isFullWidth
        searchPlaceholder="Search by member name..."
        hideRole
        hideSearchIcon
        isMultiSelect
      />
    </div>
  );
};

export default SprintMember;
